import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navigation from "@/components/Navigation"
import HeroSection from "@/components/HeroSection"
import StatsSection from "@/components/StatsSection"
import ServicesSection from "@/components/ServicesSection"
import ProcessSection from "@/components/ProcessSection"
import ProjectsSection from "@/components/ProjectsSection"
import GuaranteesSection from "@/components/GuaranteesSection"
import FAQSection from "@/components/FAQSection"
import ContactSection from "@/components/ContactSection"
import Footer from "@/components/Footer"
import ScrollReveal from "@/components/ScrollReveal"
import WaveSeparator from "@/components/WaveSeparator"
import { Button } from "@/components/ui/button";
import { Clock } from "lucide-react";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <ScrollReveal />
      <Navigation />
      <main>
        <HeroSection />
        <WaveSeparator />
        <StatsSection />
        <WaveSeparator reverse />
        <ServicesSection />
        <WaveSeparator />
        <ProcessSection />
        <WaveSeparator reverse />
        <ProjectsSection />
        <WaveSeparator />
        <GuaranteesSection />
        <WaveSeparator reverse />
        <FAQSection />
        <WaveSeparator />
        <ContactSection />
      </main>
      <Footer />
    </div>
  )
}

export default Index